import axios from 'axios';
import { stringify } from 'query-string';
import authService from './authService';
import { getAuthHeader } from './utils/authHelper';
import { getEnv } from '../utils/envUtils';

const STATISTICS_API_URL = getEnv('REACT_APP_STATISTICS_API');

const getSearchStats = (formData) => {
    const params = {
        from: formData.from,
        to: formData.to,
        actualwhat: formData.what.split(','),
    };

    if (!formData.allPlaces) {
        params.actualwhere = formData.where.split(',');
    }

    const buildRequest = () => ({
        method: 'GET',
        headers: {
            Accept: 'application/json',
            Authorization: getAuthHeader(),
        },
        url: `${STATISTICS_API_URL}/statistics/search/summaries?${stringify(params)}`,
    });

    return axios(buildRequest())
        .then(response => response.data.response)
        .catch(err => authService.refreshAndRetry(err, buildRequest)
            .then(response => response.data.response));
};

const api = {
    getSearchStats,
};

export default api;
